import React from 'react';

class PartnerWithUsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  render() {
    return (
      <>
        {this.props.partnerData
          ? (
            <section className={!this.props.blurBackground ? "background-fade" : ""}>
              <div className="container-fluid">
                <div className="container partner-container">
                  <div dangerouslySetInnerHTML={{ __html: this.props.partnerData.hero_text_block }} />
                  <div className="row">
                    <div className="card-group ps-0 pe-0">
                      {this.props.partnerData.card_block && this.props.partnerData.card_block.map((partnerCard, i) => (
                        <div className="card ms-3 me-3" key={i}>
                          <div className="card-body" dangerouslySetInnerHTML={{ __html: partnerCard.card_content }}>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : null}
      </>
    );
  }
}
export default PartnerWithUsComponent;
